import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'

import './bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
